import { Alert, Badge, Button, Col, Modal, Row } from "react-bootstrap";
import { getDescricaoTipoEventoMDFe, MDFeEventoOutput } from "../MDFe.Evento.Dto";

interface Props {
  show: boolean;
  evento: MDFeEventoOutput | undefined;
  onReturn: () => void;
  onSend: (evento: MDFeEventoOutput) => void;
  onDelete: (evento: MDFeEventoOutput) => void;
}

const MDFeEventoModalPropriedades = ({
  show,
  evento,
  onReturn,
  onSend,
  onDelete,
}: Props) => {
  const isPendente = evento?.codigoStatusEnvio === 1;

  return (
    <Modal show={show} centered onHide={onReturn}>
      <Modal.Header closeButton>
        <Modal.Title>Propriedades do Evento</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isPendente ? (
          <Alert variant="warning" className="d-flex align-items-center gap-2 py-2 mb-3">
            <span className="fs-4">⚠️</span>
            <div>
              <strong className="d-block">NÃO ENVIADO PARA A RECEITA</strong>
              <small className="text-body-secondary">
                Este evento está salvo apenas localmente e ainda não foi transmitido para a SEFAZ. Clique em "Transmitir à SEFAZ" abaixo para homologá-lo.
              </small>
            </div>
          </Alert>
        ) : evento?.numeroProtocolo ? (
          <Alert variant="success" className="d-flex align-items-center gap-2 py-2 mb-3">
            <span className="fs-4">✓</span>
            <div>
              <strong className="d-block">ENVIADO E HOMOLOGADO NA RECEITA</strong>
              <small className="text-body-secondary">
                Protocolo: {evento.numeroProtocolo}
              </small>
            </div>
          </Alert>
        ) : null}

        <Row className="mb-2">
          <Col xs={12}>
            <strong>Tipo do Evento:</strong>{" "}
            {getDescricaoTipoEventoMDFe(
              evento?.tipoEvento,
              evento?.tipoEventoDescricao
            )}
          </Col>
        </Row>
        <Row className="mb-2">
          <Col xs={12}>
            <strong>Situação na Receita:</strong>{" "}
            {isPendente ? (
              <Badge bg="warning" text="dark" className="ms-1">
                NÃO ENVIADO (Pendente)
              </Badge>
            ) : evento?.codigoStatusEnvio === 4 || evento?.numeroProtocolo ? (
              <Badge bg="success" className="ms-1">
                ENVIADO E HOMOLOGADO
              </Badge>
            ) : evento?.codigoStatusEnvio === 3 ? (
              <Badge bg="danger" className="ms-1">
                REJEITADO PELA RECEITA
              </Badge>
            ) : (
              <Badge bg="secondary" className="ms-1">
                {evento?.codigoStatusEnvioDescricao || evento?.codigoStatusEnvio}
              </Badge>
            )}
          </Col>
        </Row>
        {evento?.numeroProtocolo && (
          <Row className="mb-2">
            <Col xs={12}>
              <strong>Protocolo:</strong> {evento.numeroProtocolo}
            </Col>
          </Row>
        )}
        {evento?.descricaoMotivoResposta && (
          <Row className="mb-2">
            <Col xs={12}>
              <strong>Retorno SEFAZ:</strong>{" "}
              {evento.codigoStatusResposta
                ? `${evento.codigoStatusResposta} - `
                : ""}
              {evento.descricaoMotivoResposta}
            </Col>
          </Row>
        )}
        {evento?.cancelamento?.justificativaCancelamento && (
          <Row className="mb-2">
            <Col xs={12}>
              <strong>Justificativa:</strong>{" "}
              {evento.cancelamento.justificativaCancelamento}
            </Col>
          </Row>
        )}
        {evento?.encerramento && (
          <Row className="mb-2">
            <Col xs={12}>
              <strong>Encerramento:</strong> Data:{" "}
              {evento.encerramento.dataEncerramento} | Município IBGE:{" "}
              {evento.encerramento.codigoMunicipio}
            </Col>
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer>
        {isPendente && (
          <>
            <Button
              variant="outline-danger"
              onClick={() => {
                if (evento) {
                  onReturn();
                  onDelete(evento);
                }
              }}
            >
              Excluir
            </Button>
            <Button
              variant="outline-primary"
              onClick={() => {
                if (evento) {
                  onReturn();
                  onSend(evento);
                }
              }}
            >
              Transmitir à SEFAZ
            </Button>
          </>
        )}
        <Button variant="outline-secondary" onClick={onReturn}>
          Sair
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MDFeEventoModalPropriedades;
